export default __webpack_public_path__ + "static/media/warning.ba2cd42b.svg";